import styled, { css } from 'styled-components';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import Title from '../Text/Title/Title.js';

const DialogContainer = styled.div(({ theme: { olist: { components: { modal: { dialog }, }, }, }, }) => css `
    box-sizing: border-box;
    padding: ${dialog.padding};
  `);
const DialogModal = styled.dialog(({ size = 'large', theme: { olist: { components: { modal: { dialog, overlay }, }, }, }, }) => css `
    box-sizing: border-box;
    padding: 0;

    width: 100%;
    max-width: 100%;
    max-height: ${size === 'full' ? '100vh' : '80vh'};
    height: ${size === 'full' ? '100vh' : ''};
    border: none;
    border-top-left-radius: ${dialog.radius};
    border-top-right-radius: ${dialog.radius};
    margin-bottom: 0;

    background-color: ${dialog['background-color']};
    box-shadow: ${dialog['box-shadow']};

    @media (min-width: 592px) {
      margin: auto;
      max-width: ${dialog.size[size]['max-width']};
      border-radius: ${size === 'full' ? 0 : dialog.radius};
    }

    @media (max-width: 592px) {
      inset-block-start: auto;
    }

    &::backdrop {
      background-color: ${overlay['background-color']};
      opacity: ${overlay.opacity};
    }
  `);
const CloseModal = styled.div(({ theme: { olist: { components: { modal: { close }, }, }, }, }) => css `
    position: absolute;
    top: ${close.top};
    right: ${close.right};
  `);
const HeaderModal = styled.div(({ theme: { olist: { components: { modal: { header }, }, }, }, }) => css `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: ${header['margin-top']};

    ${Title} {
      margin: 0;
    }
  `);
const BodyModal = styled.div(({ theme: { olist: { components: { modal: { body }, }, }, }, }) => css `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    overflow: auto;

    margin-top: ${body.mobile['margin-top']};

    @media (min-width: 592px) {
      margin-top: ${body.desktop['margin-top']};
    }
  `);
const FooterModal = styled.div(({ theme: { olist: { components: { modal: { footer }, }, }, }, }) => css `
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    margin-top: ${footer['margin-top']};
    width: 100%;
  `);

export { BodyModal, CloseModal, DialogContainer, DialogModal, FooterModal, HeaderModal };
